/**
 * Utilities
 */

// Parse query string as object
function parseQueryString(query) {
  if (query.length < 1) {
    return false;
  } else {
    let vars = query.split('&');
    let query_string = {};

    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      // If first entry with this name
      if (typeof query_string[pair[0]] === 'undefined') {
        query_string[pair[0]] = decodeURIComponent(pair[1]);
        // If second entry with this name
      } else if (typeof query_string[pair[0]] === 'string') {
        let arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
        query_string[pair[0]] = arr;
        // If third or later entry with this name
      } else {
        query_string[pair[0]].push(decodeURIComponent(pair[1]));
      }
    }
    return query_string;
  }
}

export { parseQueryString };
